import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../AuthContext';

function Logout() {
  const navigate = useNavigate();
  const { setCurrentUser, setCurrentUserProfile, setTgsecretkey, setRole, isLoggingOut } = useContext(AuthContext);

  useEffect(() => {
    const performLogout = async () => {
      isLoggingOut.current = true; // 🔐 ставим блокировку
                // Удаляем токены из localStorage
                localStorage.removeItem('user_token');
                localStorage.removeItem('user_role');
      try {
        const response = await fetch('/api/auth/logout', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
        });

        if (response.ok) {
          console.log('start clear');
          // Чистим контекст
          // setCurrentUser(null);
          // setCurrentUserProfile(null);
          // setTgsecretkey(null);
          // setRole(null);
          console.log('stop clear');
          isLoggingOut.current = false;
                      navigate('/');

          
        } else {
          console.error('Logout failed');
          isLoggingOut.current = false;
        }
      } catch (error) {
        console.error('Error during logout:', error);
        isLoggingOut.current = false;
      }
    };

    performLogout();
  }, [navigate, setCurrentUser, setCurrentUserProfile, setTgsecretkey, setRole, isLoggingOut]);

  return null;
}

export default Logout;
